import {css} from "@emotion/react";
import numeral from 'numeral';
import {DateTime} from "luxon";
import {DOCUMENTS} from "../component/filePicker";
import {normalizeSync} from 'normalize-diacritics';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import xorWith from 'lodash/xorWith';
import po_boxes from "./codePostal.json";

numeral.register('locale', 'fr', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: 'G'
    }
});

export function trimFileName(fileNames) {
    const leftRightStrings = fileNames.split('.');
    //file name
    const fName = leftRightStrings[0];
    //file extension
    const fExtention = leftRightStrings[1];
    const lengthFname = fName.length;
    //if file name without extension contains more than 15 characters
    if (lengthFname > 20) {
        return fName.substr(0, 21) + "..." + fName.substr(-3) + "." + fExtention
    } else {
        return fileNames;
    }
}

export function getRoleName(role_id) {

    switch (role_id) {
        case 1:
            return "Niveau 1";
        case 2:
            return "Commerçant - Représentant";
        case 3:
            return "Niveau 5";
        case 4:
            return "Niveau 2";
        case 5:
            return "Super Utilisateur";
        case 6:
            return "Niveau 4";
        case 7:
            return "Niveau 3";
        default:
            return "ZOMBI"
    }
}

export const explainSemandeStatus = (slug, long = false) => {
    let description = '', longDescription = '';
    switch (slug) {
        case 'posted':
            description = "Postée";
            longDescription = "Le commerçant a posté la demande de CIP. La demande est en attente de vérification";
            break;
        case 'pre-processing':
            description = "En vérification";
            longDescription = "Un opérateur est en train de vérifier la demande.";
            break;
        case 'processed':
            description = "Vérifiée";
            longDescription = "La demande a passé la premiére étape de vérification. (1/3)";
            break;
        case 'in-inspection':
            description = "En inspection";
            longDescription = "La demande attend le rapport de l'Inpecteir sur le dossier.(2/3)";
            break;
        case 'out-to-inspection':
            description = "En attente d'inspection";
            longDescription = "Un inspecteur doit passer vérifier les locaux de l'établissement.";
            break;
        case 'rejected':
            description = "En attente de correction";
            longDescription = "La demande a été retournée au commerçant pour correction et mise à jour.";
            break;
        case 'waiting-approval':
            description = "En attente de signature";
            longDescription = "La demande a été  acheminée au Niveau 1 pour être visée (3/3)";
            break;
        case 'in-printing-queue':
            description = "En attente d'impression";
            longDescription = "La demande a été aprouvé et a été ajoutée à la liste des impressions de cartes.";
            break;
        case 'printing':
            description = "En impression";
            longDescription = "La demande est en train d'être imprimée";
            break;
        case 'printed':
            description = "Imprimée";
            longDescription = "La demande a été imprimée et est en attente de livraison.";
            break;
        case 'delivered':
            description = "Délivrée";
            longDescription = "La demande a été livrée au commerçant";
            break;
        case 'cancel':
            description = "Annulée";
            longDescription = "La demande a été annulée. Le processus est suspendu.";
            break;
        case 'waiting-payment':
            description = "En attente du paiement";
            longDescription = "Le commerçant a reçu l' invitation à venir payer. Il/Elle doit se présenter avec le reçu à la DCI pour que le Directeur puisse valider la demande pour l’impression.";
            break;
        default:
            description = 'En transition';
            longDescription = "Le traitement du dossier est en transition vers une autre étape.";

    }
    return long ? longDescription : description;
}

export const explainDemandeStatusLong = (slug) => {
    return explainSemandeStatus(slug, true)
}

export function prettyDate(isoDate) {
    const u = DateTime.fromSQL(isoDate).isValid ? DateTime.fromSQL(isoDate) : DateTime.fromISO(isoDate);
    return !!isoDate ? u.setLocale('fr-FR').toLocaleString(DateTime.DATETIME_MED) : '-----'
}

export function prettyDateFromIso(isoDate) {
    const u = DateTime.fromISO(isoDate);
    return !!isoDate ? u.setLocale('fr-FR').toLocaleString(DateTime.DATETIME_MED) : '-----'
}

export function stringifyFormData(fd) {
    const data = {};
    for (let key of fd.keys()) {
        data[key] = fd.get(key);
    }
    return JSON.stringify(data, null, 2);
}

export function isFileValid(file, isPicture) {

    const re = isPicture ? /(\.jpg|\.png|\.jpeg|\.tif|\.tiff)$/ : /(\.jpg|\.png|\.jpeg|\.tif|\.tiff|\.pdf)$/
    if (!file) {
        return false;
    }
    if (
        !(file.name?.toLowerCase().match(re) ||
            file.type?.split('/')[0] === 'image' ||
            file.type === 'application/pdf')
    ) {
        return false;
    } else return !(!!file && file.size > 1024000 * 4);

}

export const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

export function simplifyNumber(value, ...args) {
    // format
    let format = args[0] || '0.a';

    if (value < 1000 && format === '0.0a') {
        format = '0.a';
    }

    const num = value * 1;

    return numeral(num).format(format);
}

export const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
        const boundFunc = func.bind(this, ...args);
        clearTimeout(timerId);
        timerId = setTimeout(boundFunc, delay);
    }
}
export const throttle = (func, delay, immediate) => {
    let timerId;
    return (...args) => {
        const boundFunc = func.bind(this, ...args);
        if (timerId) {
            return;
        }
        if (immediate && !timerId) {
            boundFunc();
        }
        timerId = setTimeout(() => {
            if (!immediate) {
                boundFunc();
            }
            timerId = null;
        }, delay);
    }
}

export function padToFour(number) {
    if (number <= 9999) {
        number = ("000" + number).slice(-4);
    }
    return number;
}

export function findPostalCode(commune, departement) {
    const res = Object.keys(po_boxes[departement] || {}).filter(value => {
        return normalizeSync(po_boxes[departement][value].toLowerCase()).indexOf(normalizeSync(commune.toLowerCase())) !== -1
    })
    return res.length === 1 ? res[0] : ''
}

export function processError(res) {
    let message = '';
    if (!!res.validation_messages) {
        message = 'Il y a des erreurs dans le formulaire.';
        for (const attr in res.validation_messages) {
            if (res.validation_messages.hasOwnProperty(attr)) {
                message += `\n • ${res.validation_messages[attr]}`;
            }
        }
    } else {
        message = res.message;
    }

    return message;
}

export function getRequiredFilesList(dossiersTypesList, entreprise, dossiers) {


    const f = [];
    const types = dossiersTypesList?.sort(
        (a, b) => {
            if (a.id > b.id) return 1;
            if (b.id > a.id) return -1;

            return 0;
        }
    ) || [];

    for (const type of types) {
        let use = false;

        const required = parseInt(type.required, 10);
        if (required === 1) {
            if (type.id === 1 && [4, 5].includes(entreprise.entreprise_type_id)) {
                // no picture
            } else {
                use = true;
            }

        }

        if (required === 2) {
            if (entreprise?.nationalite === 'Etrangere') {
                use = true;//
            }
        }

        if (required === 5) {

            if (entreprise.entreprise_type_id === 1 && !!entreprise.nom_commercial) {
                use = true;//
            }
        }

        if (required === 4) {
            // Sociétés de Capitaux (Société Anonyme et en Commandite par action)
            if ([4, 5].includes(entreprise.entreprise_type_id)) {
                use = true;//
            }
        }

        if (required === 6) {
            // Sociétés de Capitaux (Société Anonyme et en Commandite par action)
            if ([2, 3].includes(entreprise.entreprise_type_id)) {
                use = true;//
            }
        }

        if (required === 7) {
            // renew
            const d = entreprise.is_renew;
            const is_renew = d === 'oui' || parseInt(d, 10) === 1 || d === true
            if (is_renew) {
                use = true;//
            }
        }

        if (required === 8) {
            if(entreprise.enteredBy === 'Personne mandatée' || entreprise.rempli_par === 'Personne mandatée' ){
                use = true;//
            }
        }
        const category = parseInt(entreprise.category, 10);
        const category2 = parseInt(type.speciality_id, 10);
        if (category > 0 && category === category2) {
            use = true;
        }

        const specialite = parseInt(entreprise.specialite?.id, 10);
        const specialite2 = parseInt(type.speciality_id, 10);
        if (specialite > 0 && specialite === specialite2) {
            use = true;
        }

        if (use) {
            const dossier = dossiers.find(value => value.type_id === type.id) || {};
            const fileObj = entreprise.files?.find(value => value.type === type.id) || {};
            const image = DOCUMENTS.find(v => v.id === type.id);

            dossier.type = type.id;
            dossier.file = fileObj.file;
            dossier.name = type.name;
            dossier.description = type.description;
            dossier.image = image?.image;
            f.push(dossier);
        } else {
            f.push(null);
        }
    }

    return f;
}

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));

export const convertBlobToBase64 = blob => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
});


/*!
 * Add items to an object at a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path to assign the value to
 * @param  {*}            val  The value to assign
 */
export const put = function (obj, path, val) {

    /**
     * If the path is a string, convert it to an array
     * @param  {String|Array} path2 The path
     * @return {Array}             The path array
     */
    let stringToPath = function (path2) {

        // If the path isn't a string, return it
        if (typeof path2 !== 'string') return path2;

        // Create new array
        const output = [];

        // Split to an array with dot notation
        path2.split('.').forEach(function (item, index) {

            // Split to an array with bracket notation
            item.split(/\[([^}]+)\]/g).forEach(function (key) {

                // Push to the new array
                if (key.length > 0) {
                    output.push(key);
                }

            });

        });

        return output;

    };

    // Convert the path to an array if not already
    path = stringToPath(path);

    // Cache the path length and current spot in the object
    const length = path.length;
    let current = obj;

    // Loop through the path
    path.forEach(function (key, index) {

        // Check if the assigned key shoul be an array
        const isArray = key.slice(-2) === '[]';

        // If so, get the true key name by removing the trailing []
        key = isArray ? key.slice(0, -2) : key;

        // If the key should be an array and isn't, create an array
        if (isArray && Object.prototype.toString.call(current[key]) !== '[object Array]') {
            current[key] = [];
        }

        // If this is the last item in the loop, assign the value
        if (index === length - 1) {

            // If it's an array, push the value
            // Otherwise, assign it
            if (isArray) {
                current[key].push(val);
            } else {
                current[key] = val;
            }
        }

        // Otherwise, update the current place in the object
        else {

            // If the key doesn't exist, create it
            if (!current[key]) {
                current[key] = {};
            }

            // Update the current place in the object
            current = current[key];

        }

    });

};

const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    })

function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180
}

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */
export async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const maxSize = Math.max(image.width, image.height)
    const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))

    // set each dimensions to double largest dimension to allow for a safe area for the
    // image to rotate in without being clipped by canvas context
    canvas.width = safeArea
    canvas.height = safeArea

    // translate canvas context to a central location on image to allow rotating around the center.
    ctx.translate(safeArea / 2, safeArea / 2)
    ctx.rotate(getRadianAngle(rotation))
    ctx.translate(-safeArea / 2, -safeArea / 2)

    // draw rotated image and store data.
    ctx.drawImage(
        image,
        safeArea / 2 - image.width * 0.5,
        safeArea / 2 - image.height * 0.5
    )
    const data = ctx.getImageData(0, 0, safeArea, safeArea)

    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height

    // paste generated rotate image with correct offsets for x,y crop values.
    ctx.putImageData(
        data,
        Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
        Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
    )

    // As Base64 string
    // return canvas.toDataURL('image/jpeg');

    // As a blob
    return new Promise((resolve) => {
        canvas.toBlob((file) => {
            resolve({
                url: URL.createObjectURL(file),
                file
            })
        }, 'image/png')
    })
}

export async function getRotatedImage(imageSrc, rotation = 0) {
    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const orientationChanged =
        rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270
    if (orientationChanged) {
        canvas.width = image.height
        canvas.height = image.width
    } else {
        canvas.width = image.width
        canvas.height = image.height
    }

    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate((rotation * Math.PI) / 180)
    ctx.drawImage(image, -image.width / 2, -image.height / 2)

    return new Promise((resolve) => {
        canvas.toBlob((file) => {
            resolve(URL.createObjectURL(file))
        }, 'image/png')
    })
}

